import { render, staticRenderFns } from "./PPVTiers.vue?vue&type=template&id=7f2c001c&scoped=true&"
import script from "./PPVTiers.vue?vue&type=script&lang=js&"
export * from "./PPVTiers.vue?vue&type=script&lang=js&"
import style0 from "./PPVTiers.vue?vue&type=style&index=0&id=7f2c001c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2c001c",
  null
  
)

export default component.exports